export const ARIA_PATH = '/home/aria';

/**
 * Whether a pathname is the full-page ARIA route. Headers use this to decide
 * whether to render the drawer or just a disabled "Ask ARIA" button, since the
 * page owns the chat runtime on that route.
 */
export const isAriaPagePath = (pathname: string): boolean =>
  pathname.replace(/\/+$/, '') === ARIA_PATH;
